import { ROUTES } from '#/config/routes';
import AuthGuard from '#/modules/infra/components/AuthGuard';
import AdminLayout from '#/modules/infra/layout/AdminLayout';
import ErrorPage from '#/modules/infra/router/ErrorPage';

import { homeRoutes } from './admin/home.routes';
import { crmRoutes } from './admin/crm.routes';
import { devRoutes } from './admin/dev.routes';
import { fmsRoutes } from './admin/fms.routes';
import { productRepairRoutes } from './admin/productRepair.routes';
import { productionRoutes } from './admin/production.routes';
import { settingRoutes } from './admin/setting.routes';
import { srmRoutes } from './admin/srm.routes';
import { warehouseRoutes } from './admin/warehouse.routes';

export const adminRoute = {
  path: ROUTES.home,
  handle: { title: '主控台' },
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  /** throw 時僅 ErrorPage，避免再包一層 AdminLayout（雙殼） */
  errorElement: <ErrorPage />,
  children: [
    ...homeRoutes,
    ...warehouseRoutes,
    ...productionRoutes,
    ...crmRoutes,
    ...productRepairRoutes,
    ...srmRoutes,
    ...fmsRoutes,
    ...settingRoutes,
    ...devRoutes,
    {
      path: '*',
      element: <ErrorPage />,
    },
  ],
};
